import { Outlet } from "react-router-dom";
import { SWRConfig } from "swr";
import { swrConfig } from "@/hooks/use-api-client";
import { AuthProvider } from "@/contexts/auth-context";
import { AppConfigProvider } from "@/contexts/app-config-context";
import { CompanyProvider } from "@/contexts/company-context";
import { WorkspaceProvider } from "@/contexts/workspace-context";
import { AuthErrorBoundary } from "@/components/auth-error-boundary";
import { isMaintenanceMode } from "@/lib/environment";

function MaintenanceMode() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Maintenance Mode</h2>
          <p className="mt-2 text-sm text-gray-600">
            We&apos;re currently performing scheduled maintenance. Please check back later.
          </p>
        </div>
      </div>
    </div>
  );
}

export function RootLayout() {
  return (
    <AuthErrorBoundary>
      <SWRConfig value={swrConfig}>
        <AuthProvider>
          <AppConfigProvider>
            <CompanyProvider>
              <WorkspaceProvider>
                {isMaintenanceMode() ? <MaintenanceMode /> : <Outlet />}
              </WorkspaceProvider>
            </CompanyProvider>
          </AppConfigProvider>
        </AuthProvider>
      </SWRConfig>
    </AuthErrorBoundary>
  );
}
